import { SxProps, Theme } from '@mui/system';
export const datePicker: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    height: '41px',
    width: '164px',
  },
};
